import { useEffect, useState, useCallback } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsCompleted,
  filterLeadsByQuery,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const COMPLETED_STATUSES = [
  "PASSED_TO_ASSEMBLY",
  "LOOP_MILLING",
  "PACKAGING",
  "READY_FOR_SHIPMENT",
  "ON_DELIVERY",
  "ORDER_DELIVERED",
  "ORDER_INSTALLED",
];

const CompletedStatus = ({ userPermission, query = "" }) => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = useCallback(
    (page = 1, size = limit) => {
      setIsLoading(true);
      return fetchStatuses("ACTIVE", COMPLETED_STATUSES, query, setLeads, setIsLoading, setTotalCount, page, size).then(
        ({ currentPage: cp }) => {
          setCurrentPage(cp);
          setLimit(size);
        }
      );
    },
    [query, limit]
  );

  useEffect(() => {
    loadData(1, limit);
  }, [query]);

  const handlePageChange = (page, size) => {
    loadData(page, size);
  };

  const filtered = filterLeadsByQuery(leads, query);

  return (
    <>
      <Table
        style={{ minWidth: 1000 }}
        size="small"
        bordered
        loading={isLoading}
        columns={orderStatusColumnsCompleted}
        dataSource={getOrderStatusDataSource(filtered)}
        pagination={false}
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
            />
          ),
        }}
      />

      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          showSizeChanger
          onChange={handlePageChange}
          onShowSizeChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default CompletedStatus;
